export default theme => ({
  root: {},
  content: {
    overflow: 'hidden'
  },
  matchingList: {
    height: 'calc(100vh - 400px) !important',
    maxHeight: 350,
    border: `1px solid ${theme.colors.grey[100]}`,
    boxSizing: 'border-box',
    borderRadius: '4px',
    '& .ag-root': {
      border: 'none !important'
    },
    '& .ag-row': {
      border: 'none !important'
    },
    '& .ag-header': {
      backgroundColor: 'transparent !important',
      border: 'none !important'
    },
    '& .ag-header-cell': {
      backgroundColor: 'transparent !important',
      borderBottom: `1px solid ${theme.colors.grey[100]} !important`,
      '&::after': {
        border: 'none !important'
      }
    },
    '& .ag-cell': {
      border: 'none !important',
      paddingLeft: 20,
      '& .ag-react-container': {
        height: '100%'
      }
    },
    '& .ag-row-last': {
      '& $matchingListCell, & $fmCell': {
        width: '100% !important'
      }
    }
  },
  matchingListCell: {
    paddingRight: 40,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.colors.grey[100]}`,
    paddingLeft: 20
  },
  fmCell: {
    paddingRight: 20,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.colors.grey[100]}`
  },
  modalLoader: {
    height: 240,
    marginTop: 30,
    textAlign: 'center'
  },
  checkboxContainer: {
    display: 'flex',
    marginTop: 16,
    marginBottom: 8
  },
  checkbox: {
    marginRight: 8
  }
});